<template>
    <div>
        <div class="topcode-wechat-notice-item" @click="updateShow">
            <span :class="'sign sign-'+notice.state">{{'UN_READ'==notice.state?'未读':'已读'}}</span>
            <div style="min-height: 66px">{{notice.content}}</div>
            <div style="text-align: right;margin-right: -30px">{{notice.createdTime}}</div>
        </div>
    </div>
</template>

<script>

    export default {
        components: {},
        props: {
            notice: {type: Object, required: true}
        },
        data() {
            return {
                show: false
            };
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {
            updateShow() {

                this.$emit('onUpdate', this.notice)
            },
            switchPanel(type, data) {
                switch (type) {
                    case "detailPopup":
                        this.show = !this.show;
                        break;
                    default:
                        break;
                }
            },
        },
        watch: {}
    };
</script>

<style lang="less" scoped>
    .topcode-wechat-notice-item {
        width: calc(100% - 50px);
        /*height: 225px;*/
        margin-bottom: 8px;
        overflow: hidden;
        position: relative;
        padding: 8px 40px 5px 10px;
        line-height: 1.6;
        border: 1px #cccccc solid;
        border-radius: 5px;
        /*background: #51c332;*/

    }

    .sign {
        &.sign-UN_READ {
            background: red;
        }
        &.sign-READ {
            background: grey;
        }
        font-family: 微软雅黑;
        text-decoration: none;
        display: block;
        position: absolute;
        right: -95px;
        width: 150px;
        height: 25px;
        font-size: 10px;
        /*background-color: red;*/
        color: #fff;
        font-weight: bold;
        line-height: 28px;
        text-align: center;
        transform: translate(-28%, -8%) rotate(40deg);
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5), inset 0 0 2px #fff;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);
    }
</style>
